import { render, staticRenderFns } from "./administrator.vue?vue&type=template&id=3dcca4c9&scoped=true&"
import script from "./administrator.vue?vue&type=script&lang=js&"
export * from "./administrator.vue?vue&type=script&lang=js&"
import style0 from "./administrator.vue?vue&type=style&index=0&id=3dcca4c9&lang=scss&scoped=true&"
import style1 from "./administrator.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3dcca4c9",
  null
  
)

export default component.exports